import { Alert, AlertTitle, Snackbar } from '@mui/material';
import { useSelector } from 'react-redux';

export default function PushNotificationSnackBar({ open, handleClose }) {
  const { pushNotification } = useSelector((state) => state.pushNotification);
  const { title, body } = pushNotification;

  const onClose = (_event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    handleClose();
  };

  return (
    <Snackbar
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      open={open}
      onClose={onClose}
      sx={{ bottom: 80 }}
    >
      <Alert
        onClose={onClose}
        severity="info"
        sx={{ width: '100%', borderRadius: 2 }}
      >
        <AlertTitle>{title}</AlertTitle>
        {body}
      </Alert>
    </Snackbar>
  );
}
